export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";